module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAQCAYAAAD9L+QYAAAAAXNSR0IArs4c6QAAALhJREFUOE/VlFENwjAYhL9TwFAADjYnDAdDAg7AwXAwHCABnEzCUPCTS7aEEOChlIfdU9OkX9rr/aeI6IANsJN0AYiIBlh5nahe0lkRMQAL4CjpMMKnvUQ2d0mF4TVQAa0kQ7NJ2UhvQDOGR0QBlJJuuS3yh/Zj7PaS2jEtjqQTlKpB0vYb3C9KleG14YZUkq6ppE/nZpyW3FY886bxL4FT9vH/U3E5LUvf3JXr8mpeKnf9g2Wu3O4BjU1OER7JVoIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menuIcon.png
// module id = 5+JZ
// module chunks = 1